export const TransactionJuram = {
  beforeCreate() {
    var tokenId = localStorage.getItem("authToken");
    var userOwnData = this.$auth.getMe();
    if (tokenId == null || userOwnData == null) {
      this.RedirectLogin();
      this.$auth.destroyToken();
      this.$auth.removeMe();
      this.$router.push({ name: "login" });
    }
    var cardHolderInfId = userOwnData.cardHolderInfId;
    // this.$axiosApi
    //   .post(`card/info/upoint`, { tokenId, cardHolderInfId })
    //   .then((response) => {
    //     var result = response.data;
    //     if (result.status === 0) {
    //       if (result.isUPoint === 1) {
    //         this.upointBalance = result.upointBalance;
    //       }
    //     }
    //   })
    this.$bonusApi
      .post(
        "/bonus-card/upoint/card",
        {
          locationKey: 200805130000000001,
          posKey: 1,
          systemId: "BONUS",
          data: {
            card_number: cardHolderInfId,
            mobile: "",
            pin_code: "NominApproved",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": "mn",
          },
        }
      )
      .then((response) => {
        var result = response.data;
        if (result.result === 0) this.upointBalance = result.balance;
        else this.upointBalance = 0;
      })
      .catch(() => {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      });
  },
  methods: {
    //get All Data
    fetchData(sendData, type) {
      this.loader = true;
      this.mTop = true;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      var pageNumber = sendData || 1;
      var transactionType = "";
      var isPartnerTransaction = 0;
      if (type === "StoreManagement") {
        isPartnerTransaction = 1;
        transactionType = "All";
      } else if (type === "All") {
        isPartnerTransaction = -1;
        transactionType = "All";
      } else {
        isPartnerTransaction = 0;
        transactionType = type;
      }
      var beginDate = this.newStartDate;
      var endDate = this.newEndDate;
      this.$axiosApi
        .post(`card/transactions`, {
          tokenId,
          cardHolderInfId,
          transactionListType: "Procedure",
          pageSize: 12,
          pageIndex: pageNumber,
          transactionType,
          isPartnerTransaction,
          beginDate,
          endDate,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.pageIndex = result.pageIndex;
            this.totalPage = result.totalPageCount;
            this.transactions = result.transactions;
            this.loader = false;
            this.mTop = false;
            this.scrollToTop();
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    //get one data bill
    openBill(value) {
      if (
        value.transactionType != "ByHand" &&
        value.transactionType != "TransferCommission" &&
        value.transactionType !== "Transfer"
      ) {
        this.loader = true;
        this.$insProgress.start();
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfID = user.cardHolderInfId;
        var invPkId = value.invPkId;
        var type = "Bonus";
        var billPkId = value.billPkId;
        this.$axiosApi
          .post(`card/get/billImage`, {
            tokenId,
            cardHolderInfID,
            billPkId,
            type,
          })
          .then((response) => {
            var result = response.data;
            this.showBill = true;
            if (result.status === 1) {
              this.billData = result.data;
              this.invPkId = invPkId;
              this.headerData = result;
            } else {
              this.billData = "";
              this.billMessage = result.message;
            }
            this.loader = false;
            this.$insProgress.finish();
          })
          .catch(() => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      }
    },
    //get one data detail
    openModal(value) {
      if (
        value.transactionType != "ByHand" &&
        value.transactionType != "TransferCommission"
      ) {
        this.loader = true;
        this.$insProgress.start();
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        var invPkId = value.invPkId;
        var invType = value.transactionType;

        this.$axiosApi
          .post(`card/transactions/detail`, {
            tokenId,
            cardHolderInfId,
            invPkId,
            invType,
          })
          .then((response) => {
            var result = response.data;
            if (result.status === 0 || result.status === 100) {
              this.modalData = result.bills;
              this.invPkId = invPkId;
              this.headerData = result;
              if (value.transactionType == "Transfer") {
                this.showTransferModal = true;
              }
              if (value.transactionType == "ServiceCommission") {
                this.showServiceCommissionModal = true;
              } else {
                this.showModal = true;
              }

              this.loader = false;
              this.$insProgress.finish();
            } else if (result.status === 201) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
          })
          .catch(() => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      }
    },
    //search date filter
    dateFilter(Startdate, Enddate) {
      var beginDate = Startdate.substring(0, 10);
      var endDate = Enddate.substring(0, 10);
      if (beginDate.length > 0 && endDate.length > 0) {
        this.newStartDate = Startdate;
        this.newEndDate = Enddate;
        this.loader = true;
        this.mTop = true;
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        var transactionListType = "Procedure";
        var transactionType = this.selectTransactionType || "All";
        if (this.selectTransactionType === "StoreManagement") {
          var isPartnerTransaction = 1;
        } else if (this.selectTransactionType === "All") {
          isPartnerTransaction = -1;
        } else {
          isPartnerTransaction = 0;
        }
        this.$axiosApi
          .post(`card/transactions`, {
            tokenId,
            cardHolderInfId,
            transactionListType,
            transactionType,
            isPartnerTransaction,
            pageSize: 12,
            pageIndex: 1,
            beginDate,
            endDate,
          })
          .then((response) => {
            var result = response.data;
            if (result.status === 0) {
              this.pageIndex = result.pageIndex;
              this.totalPage = result.totalPageCount;
              this.transactions = result.transactions;
              this.loader = false;
              this.mTop = false;
            } else if (result.status === 201) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
          })
          .catch(() => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      } else {
        this.errorMessage = "Утгыг гүйцэт бөглөнө үү ?";
        this.errorModal = true;
      }
    },

    //get type find
    filterType(value, partnerId) {
      this.selectTransactionType = value;
      this.loader = true;
      this.mTop = true;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      var transactionListType = "Procedure";
      var transactionType = value;
      var isPartnerTransaction = partnerId;
      this.$axiosApi
        .post(`card/transactions`, {
          tokenId,
          cardHolderInfId,
          transactionListType,
          transactionType,
          isPartnerTransaction,
          pageSize: 12,
          pageIndex: 1,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.pageIndex = result.pageIndex;
            this.totalPage = result.totalPageCount;
            this.transactions = result.transactions;
            this.loader = false;
            this.mTop = false;
            //this.selectTransactionType = this.transactions[0].transactionType;
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
};
